import { render, staticRenderFns } from "./EmailLoginButton.vue?vue&type=template&id=bd77d6cc&scoped=true&"
import script from "./EmailLoginButton.vue?vue&type=script&lang=js&"
export * from "./EmailLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./EmailLoginButton.vue?vue&type=style&index=0&id=bd77d6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd77d6cc",
  null
  
)

/* custom blocks */
import block0 from "./EmailLoginButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports